import { useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import { useWaapSecurityCharts, SECURITY_TIME_RANGES, type SecurityTimeRange } from '@/api/waap';
import { useWaapWebsite } from '@/pages/services/waap/waap-context';
import { WaapAnalyticsBoard } from './WaapAnalyticsBoard';

/**
 * Analytics → Security Overview — NATIVE charts (Superset dashboard 108) rendered
 * through the shared board shell. The wide Malicious Request Detail log lands in
 * the grid's full-width lane automatically (>5 columns).
 */
export function SecurityOverviewTab() {
  const { selected } = useWaapWebsite();
  const [range, setRange] = useState<SecurityTimeRange>('Last 4 hours');
  const [domains, setDomains] = useState<string[]>([]);
  const query = useWaapSecurityCharts(selected?.domainId, range, domains);
  return (
    <WaapAnalyticsBoard
      icon={<ShieldAlert size={26} />}
      label="security"
      ranges={SECURITY_TIME_RANGES}
      range={range}
      onRangeChange={setRange}
      domains={domains}
      onDomainsChange={setDomains}
      query={query}
    />
  );
}
